<audio #audio2>
</audio>
<h1 mat-dialog-title class="text-center mb-0 fw-bold">Assistant voice selection</h1>

<mat-divider></mat-divider>

<mat-dialog-content class="mt-1">
    <div class="d-flex justify-content-around">
        <mat-form-field appearance="outline" class="w-100 m-2">
            <mat-label>Filter by gender</mat-label>
            <mat-select [formControl]="genderChangeValue" (selectionChange)="applyFilter()">
                <mat-option *ngFor="let gender of genders" [value]="gender">{{gender}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 m-2">
            <mat-label>Filter by accent</mat-label>
            <mat-select [formControl]="accentChangeValue" (selectionChange)="applyFilter()">
                <mat-option *ngFor="let accent of accents" [value]="accent">{{accent}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 m-2">
            <mat-label>Filter by providers</mat-label>
            <mat-select [formControl]="providersChangeValue" (selectionChange)="applyFilter()">
                <mat-option *ngFor="let providers of providers" [value]="providers">{{providers}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>

    <div class="mat-elevation-z8" [hidden]="isLoading">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Name Column -->
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let row"> {{row.name}} </td>
            </ng-container>

            <!-- Accent Column -->
            <ng-container matColumnDef="Accent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Accent</th>
                <td mat-cell *matCellDef="let row"> {{row.accent}} </td>
            </ng-container>

            <!-- Gender Column -->
            <ng-container matColumnDef="Gender">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Gender</th>
                <td mat-cell *matCellDef="let row"> {{row.gender}} </td>
            </ng-container>


            <!-- Provider Column -->
            <ng-container matColumnDef="Provider">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider</th>
                <td mat-cell *matCellDef="let row"> {{row.voiceProvider}} </td>
            </ng-container>


            <!-- # Play Column -->
            <ng-container matColumnDef="Play">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Play</th>
                <td mat-cell *matCellDef="let row">
                    <button (click)="playVoice(row)" [disabled]="!row.sample || row.sample == ''" mat-mini-fab class="bg-light text-dark"
                        aria-label="Example icon button with a delete icon">
                        <mat-icon>{{isVoicePlaying && playingVoiceId == row.id ? 'stop' :
                            'play_arrow' }}</mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- # Action Column -->
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button color="primary" (click)="onSelectClicked(row)">Select</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex justify-content-around mt-1">
    <button mat-raised-button mat-dialog-close class="w-50" color="warn">Close</button>
</mat-dialog-actions>